import { render, staticRenderFns } from "./TTDialog.vue?vue&type=template&id=5ce230ce&"
import script from "./TTDialog.vue?vue&type=script&lang=js&"
export * from "./TTDialog.vue?vue&type=script&lang=js&"
import style0 from "./TTDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports